import React, { Fragment, useCallback, useEffect, useState } from 'react';
import moment from 'moment-timezone';

import { Cron } from 'react-js-cron';


import logoImage from '../../../images/three-sixty-image/AvanadeLogo.png';
import { Ws360Wheel } from '../components/360Wheel/360Wheel';
import { threeSixtyData } from '../components/360Wheel/ThreeSixtyData';
import { WsThreeSixtyWheel } from "../components/DynamicThreeSixtyWheel/DynamicThreeSixtyWheel";


import { WsWheelItem, WsWheelRecharts } from "./WheelRecharts";
import { NavLink, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";
import { ActionButton, BaseButton, Breadcrumb, Button, DefaultButton, Dialog, DialogFooter, DialogType, Dropdown, DropdownMenuItemType, IBreadcrumbItem, Icon, IconButton, IDropdownOption, Label, PrimaryButton, SearchBox, Shimmer, TextField } from "office-ui-fabric-react";
import { getBoardMetrics, WsScoreDashboard, WsServiceDashboard, WsTriage } from "./ScoreDashboard";



import { WsDecodeBoardInterface, WsDecodeData, WsDecodeSource, WsDecodeProfile, WsDecodeTable, WsDecodeMetric, WsDecodeField, WsDecodeAction } from '../../../../../core/src/interfaces';






import { Loading } from "../../Shared";
import { apiGet, apiPost } from "../../../helpers-sales";



import { WsDecodeSearchBox } from "./DecodePage";
import { WsDecodeClassification, WsSalesOrganizationType } from "../../../enums";



import { generateDataValueList, getLabelList } from "./decode-data";
import { WsTimestamp } from "../../DateTime/Timestamp";
import { WsNumberField } from "../../Controls/Form/NumberField";





import 'antd/dist/antd.css';

import 'react-js-cron/dist/styles.css';




import './DecodeMetrics.scss';









type WsDecodeDataSourceDialogProps = {
  // source:    WsDecodeSource;
  onCancel: () => void;
  onSave:   () => Promise<void>;
};

const WsDecodeDataSourceDialog = (props: WsDecodeDataSourceDialogProps) => {

  const [ sourceType, setSourceType ] = useState<string>('');

  const [ sourceName, setSourceName ] = useState<string>('');

  const [value, setValue] = useState('30 5 * * 1,6');

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.onCancel();
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.onCancel();
  };

  const onClickSave = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.onSave();
  };

  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        title: 'Add Data Source',
        type: DialogType.normal
      }}
      modalProps={{
        className: 'ws-decode-data-source-dialog',
        isBlocking: false,
        styles: {
          // main: { width: 700 }
        }
      }}
    >
      <Fragment>
        <div className="ws-decode-data-source-form">

          <TextField
            label="Name"
            // underlined
            placeholder="Enter Name"
            onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
              if (newValue) {
                setSourceName(newValue);
              } else {
                setSourceName('');
              }
            }}
            value={sourceName}
          />

          <br />

          {/* <TextField
            label="Name:"
            // underlined
            placeholder="Enter Name"
            onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
              if (newValue) {
                setSourceName(newValue);
              } else {
                setSourceName('');
              }
            }}
            value={sourceName}
          /> */}

          <Dropdown
            label={`Entity`}
            options={[
              { key: '1', text: 'User'        },
              { key: '2', text: 'Group'       },
              { key: '3', text: 'Device'      },
              { key: '4', text: 'Application' },
              { key: '5', text: 'Platform'    },
              { key: '6', text: 'Service'     },
            ]}
            onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
              if (option) {
              }
            }}
            placeholder="Select Entity"
            // selectedKey={action.metricId}
          />

          <br />

          <Dropdown
            label={`Source`}
            options={[
              { key: '1', text: 'Microsoft Graph'        },
              { key: '2', text: 'Microsoft Intune'     },
              { key: '3', text: 'Log Analytics'     },
              { key: '4', text: 'Happy Signals' },
              { key: '5', text: 'Nexthink'      },
              { key: '6', text: 'ServiceNow'     },
              { key: '7', text: 'Workday'    },
            ]}
            onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
              if (option) {
              }
            }}
            placeholder="Select Source"
            // selectedKey={action.metricId}
          />

          <br />

          <TextField
            label="Query"
            // underlined
            placeholder="Enter Query"
            onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
              // if (newValue) {
              //   setSourceName(newValue);
              // } else {
              //   setSourceName('');
              // }
            }}
            // value={sourceName}
          />

          <br />
        



          <Label>Schedule</Label>

          <Cron
            clockFormat="24-hour-clock"
            allowedDropdowns={[
              'period',
              'months',
              'month-days',
              'week-days',
              'hours',
              'minutes'
            ]}

            allowedPeriods={[
              // 'year',
              'month', 'week', 'day', 'hour',
              // 'minute',
              // 'reboot'
            ]}

            value={value} setValue={setValue}
          />

          {/* <Dropdown
            label={`Source`}
            options={[
              { key: '1', text: 'Microsoft Graph'        },
              { key: '2', text: 'Microsoft Intune'     },
              { key: '3', text: 'Log Analytics'     },
              { key: '4', text: 'Happy Signals' },
              { key: '5', text: 'Nexthink'      },
              { key: '6', text: 'ServiceNow'     },
              { key: '7', text: 'Workday'    },
            ]}
            onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
              if (option) {
              }
            }}
            placeholder="Select Source"
            // selectedKey={action.metricId}
          /> */}

          <br />
        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} disabled={(sourceName && sourceType) ? false : true} />
        </>
      </DialogFooter>
    </Dialog>
  );
};






export {
  WsDecodeDataSourceDialog
};
